import Icons from '../assets/icons';

const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, '');

// Model names as stored on `model.model_name` (DB) or produced by modelDefinitions.json
// fallbackLabel that don't normalize to an exact Icons key.
const MODEL_ICON_OVERRIDES = {
  firesmoke: 'Fire',
  twodoors: 'TwoDoors',
  opendoors: 'TwoDoors',
  dangerzone: 'Danger',
  unprotectededge: 'UnprotectedEdge',
  guardrail: 'GuardRail',
  safetyrail: 'SafetyRail',
  carryingloads: 'CarryingLoads',
  vehicletopedestriandistance: 'VehicleDistance',
  thevehiclepedestrianmaximumapproachdistance: 'VehicleDistance',
  ergonomicanalysis: 'ErgonomyAnalysis',
  ergonomicsanalysis: 'ErgonomyAnalysis',
  foreignobject: 'ForeignObject',
  handraise: 'HandRaise',
  capacityviolation: 'CapacityViolation',
  onboardppe: 'OnboardPPE',
  emptyzone: 'Empty',
  phonezone: 'Water',
};

const ICON_LOOKUP = Object.keys(Icons).reduce((acc, key) => {
  acc[normalize(key)] = key;
  return acc;
}, {});

// Resolves a backend model name (e.g. "Foreign Object", "Hand raise") to a key in
// webapp/src/assets/icons. Falls back to the generic "Alert" icon rather than
// throwing, since new/renamed models can reach the UI before an icon is added.
export function getIconForModel(modelName) {
  if (!modelName) return 'Alert';

  const normalized = normalize(modelName);
  if (MODEL_ICON_OVERRIDES[normalized]) return MODEL_ICON_OVERRIDES[normalized];
  if (ICON_LOOKUP[normalized]) return ICON_LOOKUP[normalized];

  return 'Alert';
}
